import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HotGrid from "./components/HotGrid";
import TodayContent from "./components/TodayContent";
import CTASection from "./components/CTASection";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "在线吃瓜官网",
  url: "https://zaixianchigua.com",
  description:
    "在线吃瓜官网 - 直击网红塌房现场，每日黑料实时追踪，免费在线吃瓜。全网最新网红塌房、黑料爆料、吃瓜视频合集。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://zaixianchigua.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const breadcrumbJsonLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "首页",
      item: "https://zaixianchigua.com",
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotGrid />
        <TodayContent />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}